module.exports = __webpack_public_path__ + "media/images/demo/m_site_template/AF2J5PRD-8aa5745bcda814ed6c8e0f8ae4d377b6.png";